import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (hash) {
      const targetId = decodeURIComponent(hash.replace("#", ""));
      const timer = window.setTimeout(() => {
        const node = document.getElementById(targetId);
        if (node) {
          node.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 120);
      return () => window.clearTimeout(timer);
    }

    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="Scroll to top"
      data-testid="scroll-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed right-5 bottom-6 md:right-8 md:bottom-8 z-40 grid place-items-center h-11 w-11 rounded-sm border border-white/15 bg-ink-charcoal/80 text-brand-white backdrop-blur transition-all duration-500 hover:border-brand-yellow hover:text-brand-yellow ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"}`}
    >
      <ArrowUp className="h-4 w-4" />
    </button>
  );
}
